import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash', // hash or history
    base: process.env.BASE_URL,
    routes: [
        //首页
        {
            path: '/',
            name: 'home',
            component: Home,
            meta:{
                keepAlive:true
            }
        },
        //人才引进
        {
            path: '/talent',
            name: 'talent',
            component: () => import('./views/secondPage/Talent.vue'),
            meta:{
                keepAlive:true
            }
        },
        //新闻资讯
        {
            path: '/news',
            name: 'news',
            component: () => import('./views/secondPage/News.vue'),
            meta:{
                keepAlive:true
            }
        },
        //飞地
        {
            path: '/enclave',
            name: 'enclave',
            component: () => import('./views/secondPage/Enclave.vue'),
            meta:{
                keepAlive:true
            }
        },
        //详情页
        {
            path: '/detail',
            name: 'detail',
            component: () => import('./views/secondPage/Detail.vue'),
            meta:{
                keepAlive:true
            }
        },
        //蒙科聚
        {
            path: '/mengkeju',
            name: 'mengkeju',
            component: () => import('./views/secondPage/Mengkeju.vue'),
            meta:{
                keepAlive:true
            }
        },
        //创业孵化
        {
            path: '/incubator',
            name: 'incubator',
            component: () => import('./views/secondPage/Incubator.vue'),
            meta:{
                keepAlive:true
            }
        },
        //关于我们
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: () => import('./views/secondPage/AboutUs.vue'),
            meta:{
                keepAlive:true
            }
        },
    ],
    scrollBehavior: (to,from,savePosition) => {
        if(savePosition && from.name !== 'home' && to.name !== 'detail' ){
            return savePosition
        }else{
            return {x:0,y:0}
        }
    },
})
